



























import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Location } from "vue-router";

@Component({})
export default class HeaderMenuDesktop extends Vue {
  @Prop({ required: true }) public entries: Location[];
  @Inject("normalizeName") public normalizeName: (name: string) => string;

  private closeMenu(): void {
    this.$store.dispatch("ui/setMenuVisible", false);
  }
}
